import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { ta } from "date-fns/locale";

export default function StatusList({ project_id, tableData, applyCounter }) {
  const [showStatusList, setShowStatusList] = useState(false);
  const [totalAdded, setTotalAdded] = useState(0);
  // const [noInfo, setNoInfo] = useState(0)
  const [responded, setResponded] = useState(0);
  const [interested, setInterested] = useState(0);
  const [partially, setPartially] = useState(0);
  const [notAvail, setNotAvail] = useState(0);
  const [participated, setParticipated] = useState(0);
  const [prjNote, setPrjNote] = useState("");
  const [noteLeftBy, setNoteLeftBy] = useState("");
  const [noteLeftAt, setNoteLeftAt] = useState("");
  const [showPrjNote, setShowPrjNote] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [noteCount, setNoteCount] = useState(0);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    const url = `${API_URL}prj-status-list/` + project_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === "success") {
        setPrjNote(data.projectNote);
        setNoteLeftBy(data.noteLeftBy);
        setNoteLeftAt(data.noteLeftAt);
        setShowStatusList(true);
      }
    })
    .catch((err) => console.log(err));
  }, [project_id, noteCount]);

  const handleNoteUpdate = () => {
    setLoadingPopup(true);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}update-project-note/` + project_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ projectNote: prjNote }),
    })
    .then((res) => res.json())
    .then((data) => {
      setLoadingPopup(false);
      setShowPrjNote(false);
      if (data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Project Note updated successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        setNoteCount(noteCount + 1);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    })
    .catch((err) => {
      setLoadingPopup(false);
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    });
  };

  const countStatusGroups = (tableData) => {
    return tableData.reduce((acc, expert) => {
      const status = expert.expertStatus;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
  };

  useEffect(() => {
    if (tableData.length > 0) {
      const statusGroups = countStatusGroups(tableData);
      setTotalAdded(tableData.length);
      setResponded(statusGroups.Responded || 0);
      setInterested(statusGroups.Interested || 0);
      setPartially(statusGroups["Partially Available"] || 0);
      setNotAvail(statusGroups["Not Interested"] || 0);
      setParticipated(statusGroups.Participated || 0);
    }
  }, [JSON.stringify(tableData)]);

  return (
    <>
      {showStatusList ? (
        <div className="prj-details-list-icon" style={{ marginTop: "4px" }}>
          <span style={{ fontSize: "16px" }}>
            <div className="all-participation-prj-details">
              <button
                className={
                  prjNote === "" || prjNote === null ? "btn flex items-center gap-1 max-w-[80px] overflow-hidden" : "btn base-btn flex items-center gap-1 max-w-[80px] overflow-hidden"
                }
                style={{
                  height: "34px",
                  margin: "0",
                  fontSize: "14px",
                  marginRight: "4px",
                }}
                onClick={() => setShowPrjNote(true)}
              >
                <i
                  className="fa-solid fa-pencil shrink-0"
                ></i>
                <span className="truncate min-w-0">Note</span>
              </button>

              {showPrjNote && (
                <div className="prjNote-popup-wrapper">
                  <div className="tab-pane fade show prjNote-div position-relative">
                    <i
                      className="pptlist-close-icon fa-regular fa-rectangle-xmark"
                      style={{
                        fontSize: "22px",
                        top: "1px",
                        right: "2px",
                        marginTop: "0",
                      }}
                      onClick={() => setShowPrjNote(false)}
                    ></i>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="mb-3">Project Note</h5>
                      <div>
                        {noteLeftBy && (
                          <>
                            <span>{noteLeftBy},</span>
                            <input
                              type="datetime-local"
                              className="prjdetails-date-without-icon"
                              style={{ fontSize: "14px", marginTop: "14px" }}
                              value={new Date(noteLeftAt)
                                .toISOString()
                                .slice(0, 16)}
                              readOnly
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Write project note here..."
                            value={prjNote}
                            onChange={(e) => setPrjNote(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <center>
                        <button
                          className="btn btn-light"
                          onClick={() => setShowPrjNote(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn base-btn"
                          style={{ marginLeft: "6px" }}
                          onClick={handleNoteUpdate}
                        >
                          Update
                        </button>
                      </center>
                    </div>
                  </div>
                </div>
              )}
              {loadingPopup && (
                <div className="linkedin-popup-wrapper">
                  <div className="tab-pane fade show linkedin-div">
                    <center>
                      <p style={{ fontSize: "18px" }}>Please wait. . .</p>
                      <br />
                      <img
                        src={LoadingIcon}
                        alt=""
                        style={{ width: "50px", marginRight: "5px" }}
                      />
                    </center>
                  </div>
                </div>
              )}

              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div className="total-experts" title="Total Added and Applied">
                  <i className="fa-solid fa-users" />
                  <span>{totalAdded}</span>
                  {applyCounter && (<p>{'/'}{applyCounter.total}</p>)}
                </div>
              </span>
              {/* <span style={{marginRight: '16px'}}>
               <div className="interested-experts" title="No Information" 
               // style={{color: '#887d7d'}}
               >
                     <i className="fa-solid fa-users-gear"></i>
                     <span>{noInfo}</span>
               </div>
               </span> */}
              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div
                  className="interested-experts"
                  title="Responded"
                  // style={{color: '#4faa7b'}}
                >
                  <i className="fa-solid fa-user-shield"></i>
                  <span>{responded}</span>
                </div>
              </span>
              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div
                  className="interested-experts"
                  title="Interested"
                  // style={{color: '#82c41f'}}
                  style={{ color: interested > 0 ? "#82c41f" : "#365561" }}
                >
                  <i className="fa-solid fa-user" />
                  <span>{interested}</span>
                </div>
              </span>
              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div
                  className="interested-experts"
                  title="Partially Available"
                  // style={{color: '#ffc000'}}
                >
                  <i className="fa-solid fa-user-clock"></i>
                  <span>{partially}</span>
                </div>
              </span>
              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div
                  className="interested-experts"
                  title="Not Interested"
                  style={{ color: notAvail > 0 ? "#ff3333" : "#365561" }}
                >
                  <i className="fa-solid fa-user-xmark"></i>
                  <span>{notAvail}</span>
                </div>
              </span>
              <span style={{ marginRight: "16px", marginTop: "4px" }}>
                <div
                  className="interested-experts"
                  title="Participated"
                  style={{ color: participated > 0 ? "green" : "#365561" }}
                >
                  <i className="fa-solid fa-user-check"></i>
                  <span>{participated}</span>
                </div>
              </span>
            </div>
          </span>
        </div>
      ) : null}
    </>
  );
}
